import {
  object, string,
} from 'yup';
import { MY_FORM_FIELD_TEXT } from '../../form/form-constants';

const nameEmail = 'email';
const namePassword = 'password';

export const seedLoginFields = [
  {
    name: nameEmail,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.login.form.email',
    inputProps: {
      autoFocus: true,
    },
  },
  {
    name: namePassword,
    type: MY_FORM_FIELD_TEXT,
    labelId: 'seed.login.form.password',
    inputProps: {
      type: 'password',
    },
  },
];

export const seedLoginValidationSchema = object({
  [nameEmail]: string()
    .trim()
    .email('seed.login.form.email.valid')
    .required('seed.login.form.email.required'),
  [namePassword]: string()
    .required('seed.login.form.password.required'),
});
